/** How close to the scroll area's top or bottom edge the pointer starts scrolling it. */
export const AUTO_SCROLL_EDGE_PX = 60;
/** The fastest it scrolls, in pixels per animation frame — reached at the edge and beyond it. */
export const AUTO_SCROLL_MAX_SPEED = 18;

/**
 * How far a drag scrolls its scroll area this frame: negative up, positive down, 0 not at all.
 *
 * Native drag and drop does not scroll a panel that scrolls on its own, so a column dragged in the
 * sidebar could only go as far as the visible part of the list. Near an edge the list scrolls, faster
 * the closer the pointer gets; past the edge (over the sidebar's header or footer) it keeps the top
 * speed, so the user can just push towards where the column should go.
 */
export const autoScrollStep = (pointerY: number, area: { top: number; bottom: number }, edge = AUTO_SCROLL_EDGE_PX, maxSpeed = AUTO_SCROLL_MAX_SPEED): number => {
  // A short area: the two edge bands would overlap and fight, so each takes at most a third of it.
  const band = Math.min(edge, (area.bottom - area.top) / 3);
  if (band <= 0) return 0;
  const intoTop = area.top + band - pointerY;
  if (intoTop > 0) return -Math.round(maxSpeed * Math.min(1, intoTop / band));
  const intoBottom = pointerY - (area.bottom - band);
  if (intoBottom > 0) return Math.round(maxSpeed * Math.min(1, intoBottom / band));
  return 0;
};
